import React, {Component} from "react";
import axios from "axios";
import {ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../configuration";
import ComplaintTitleBar from "./ComplaintTitleBar/ComplaintTitleBar";
import QualityComplaintTable from "./QualityComplaintTable/QualityComplaintTable";
import "./NewQualityComplaint.css";

class NewQualityComplaint extends Component{


    constructor(props) {
        super(props);
        this.state = {
            items: [1, 2, 3, 4],
            inquiries: [],
            totalItemCount: 0,
            activePage: 1,
            searchData : {
                searchText : null,
                statusCodes : [],
                searchStartDate :null,
                searchEndDate : null,
                page : 0,
                size : 5
            }
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        // this.onChangeNew = this.onChangeNew.bind(this);
        // this.onChangeAnswered = this.onChangeAnswered.bind(this);
        // this.onChangeClose = this.onChangeClose.bind(this)
        this.addStatusToArray = this.addStatusToArray.bind(this);
        this.removeStatusFromArray = this.removeStatusFromArray.bind(this);
        this.setSearchStatus = this.setSearchStatus.bind(this);
        this.setSearchTimeRange = this.setSearchTimeRange.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.setSearchTimePeriod = this.setSearchTimePeriod.bind(this);
        this.setSearchText = this.setSearchText.bind(this);
        this.getFilteredComplaints = this.getFilteredComplaints.bind(this);
    }

    formatDate = (date) => {
        let today = new Date(date);

        // let todayPlus = today.getDate() +1;
        let todayPlus = today.getDate();
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),

            day = '' + todayPlus,

            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        // console.log("today ..-> ", todayPlus);
        return [year, month, day].join('-');
    };

    setSearchTimePeriod = (period) => {
        let periodCode = period;
        console.log("PERIOD quolity ====> ", periodCode);

        let today_date = new Date();
        // console.log("TODAY DATE ====> ", today_date.getFullYear()+"-"+today_date.getUTCMonth()+"-"+today_date.getDay());
        let todayDate = new Date();
        let today = this.formatDate(today_date);

        let week = new Date(todayDate.setDate(todayDate.getDate()-7));
        let month = new Date(todayDate.getFullYear(), new Date().getMonth(),-1);
        let year = new Date(new Date().getFullYear(), 0, -1);

        let beforeWeek = this.formatDate(week);
        let beforeMonth =this.formatDate(month);
        let beforeYear =this.formatDate(year);

        let searchData = {...this.state.searchData};
        searchData.searchEndDate = today;
        if(periodCode == 1){
            let dateBeforeToday = new Date();
            dateBeforeToday.setDate(dateBeforeToday.getDate()-1);
            searchData.searchStartDate = this.formatDate(dateBeforeToday);
            searchData.searchEndDate = today;
        }else if(periodCode == 2){
            searchData.searchStartDate = beforeWeek;
            searchData.searchEndDate = today;
        }else if(periodCode == 3){
            searchData.searchStartDate = beforeMonth;
            searchData.searchEndDate = today;
        }else if(periodCode == 4){
            searchData.searchStartDate = beforeYear;
            searchData.searchEndDate = today;
        } else if (periodCode == '全て') {
            searchData.searchStartDate = null;
            searchData.searchEndDate = null;
        }
        else{
            searchData.searchStartDate = this.formatDate(today_date.getFullYear()-100+"-"+today_date.getMonth()+"-"+today_date.getDay());
            searchData.searchEndDate = this.formatDate(today_date.getFullYear()+100+"-"+today_date.getMonth()+"-"+today_date.getDay());
        }

        // this.setState({
        //     searchData
        // }, ()=> this.getFilteredOrders());
        this.setState({
            searchData
        }, ()=> this.getFilteredComplaints());
    };

    setSearchText = (event) => {

        let searchData = {...this.state.searchData};

        searchData.searchText = event.target.value;

        this.setState({
            searchData
        },()=>this.getFilteredComplaints())

    };

    setSizeAndPage = () => {

        let searchData = {...this.state.searchData};

        searchData.page = 1;
        searchData.size = 10;

        this.setState({
            searchData
        },()=>this.getFilteredComplaints())

    };

    getFilteredComplaints = () => {
        let searchData = {...this.state.searchData};

        if (searchData.searchStartDate !== null && searchData.searchEndDate !== null) {
            searchData.searchStartDate = searchData.searchStartDate + "T00:00:00.000000 ";
            searchData.searchEndDate = searchData.searchEndDate + "T00:00:00.000000 ";
        } else {
            searchData.searchStartDate = null;
            searchData.searchEndDate = null;
        }

        searchData.page = this.state.activePage-1;
        if(this.state.searchData.statusCodes == []){
            searchData.statusCodes = ["NEW"];
        }

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.post(RESOURCE_BASE_URL + 'api/quality-complaint/admin/multi-search', searchData, axiosConfig)
            .then((res) => {
                this.setState({
                    inquiries : res.data.complaints.content,
                    totalItemCount: res.data.rowCount
                })
                // console.log("complaint SEARCH DATA2 ===> ", this.state.inquiries);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    setSearchTimeRange = (name, value) => {

        let today_date = new Date();
        let today = this.formatDate(today_date);

        let years = today_date.getFullYear() - 100;

        let searchData = {...this.state.searchData};
        if(name === "from"){
            searchData.searchStartDate = value;
            if(value === null){
                searchData.searchStartDate = this.formatDate(new Date("1920-01-01"));
            }
        }else{
            searchData.searchEndDate = value;
            if(value === null){
                searchData.searchEndDate = today;
            }
        }

        this.setState({
            searchData
        },()=> this.getFilteredComplaints());
    };


    addStatusToArray = (array1, array2) => {
        let newArray = array1.concat(array2);
        // removing duplicates
        return Array.from(new Set(newArray));
    };

    removeStatusFromArray = (array1, array2)=> {
        let myArray = array1;
        myArray = myArray.filter(( el ) => {
            return array2.indexOf( el ) < 0;
        } );
        return myArray;
    };

    setSearchStatus = (event) => {

        let statusCode = event.target.value;
        let checked = event.target.checked;
        // console.log("STATUS CODE ===> ",event.target.value);

        let newInquiries = ["NEW"];
        let replied = ["REPLIED"];
        let closed = ["CLOSED"];
        let unreplied = ["UNREPLIED"];

        let searchData = {...this.state.searchData};

        let status = [];

        if(checked){
            if(statusCode == 0){
                status= this.addStatusToArray(searchData.statusCodes, replied);
            }
            else if(statusCode == 1){
                status= this.addStatusToArray(searchData.statusCodes, unreplied);
            }
            else if(statusCode == 2){
                status= this.addStatusToArray(searchData.statusCodes, newInquiries);
            }
            else if(statusCode == 3){
                status= this.addStatusToArray(searchData.statusCodes, closed);
            }
        }
        else{
            if(statusCode == 0){
                status= this.removeStatusFromArray(searchData.statusCodes, replied);
            }
            else if(statusCode == 1){
                status= this.removeStatusFromArray(searchData.statusCodes, unreplied);
            }
            else if(statusCode == 2){
                status= this.removeStatusFromArray(searchData.statusCodes, newInquiries);
            }
            else if(statusCode == 3){
                status= this.removeStatusFromArray(searchData.statusCodes, closed);
            }
        }

        searchData.statusCodes = status;

        this.setState({
            searchData
        },()=>this.getFilteredComplaints());

    };

    handlePageChange = (pageNumber) => {
        this.setState({activePage: pageNumber},()=>this.getFilteredComplaints());

        let offset = (pageNumber - 1) * ITEM_COUNT_PER_PAGE;
        let searchData = {...this.state.searchData};
    };

    componentDidMount() {

        let searchData = {...this.state.searchData};

        let todayDate = new Date();

        let today = this.formatDate(todayDate);
        searchData.statusCodes = ["NEW"];
        searchData.searchEndDate = today;
        let days = todayDate.getDate()-1;
        todayDate.setDate(days);
        searchData.searchStartDate = this.formatDate(todayDate);

        this.setState({
            searchData
        },()=>this.getFilteredComplaints());

    }

    render() {

        // console.log("complaint SEARCH DATA ===> ", this.state.searchData.searchStartDate);

        return (
            <div className="admin-inquiry-content">
                <div className="admin-inquiry-div">
                    <ComplaintTitleBar
                        setSearchStatus = {this.setSearchStatus}
                        setSearchText = {this.setSearchText}

                    />
                   <div className="admin-tables-wrapper">
                       <QualityComplaintTable handlePageChange={this.handlePageChange}
                                              totalItemCount={this.state.totalItemCount}
                                              activePage={this.state.activePage}
                                              inquiries={this.state.inquiries}
                                              setSearchStatus = {this.setSearchStatus}
                                              setSearchTimeRange = {this.setSearchTimeRange}
                                              setSearchTimePeriod = {this.setSearchTimePeriod}
                                              getFilteredComplaints = {this.getFilteredComplaints}

                       />
                   </div>
                </div>
            </div>
        )
    }
}
export default NewQualityComplaint;



// WEBPACK FOOTER //
// ./src/components/Admin/NewQualityComplaint/NewQualityComplaint.js